$(function() {
    $('.video-settings-box').on('click', function() {
        if ($(window).width() < 768) {
            let x = $(this).find(".video-settings-box-cover")
            if (x.css('opacity') == 1) {
                x.animate({'opacity' : 0}, 0)    
            } else {
                x.animate({'opacity' : 1}, 0)
            }
        }
    })
});